var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[63716]) {
		innerRemote = __webpack_require__(63716);
	}
	var gs = __webpack_require__.g || globalThis
	gs["term"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();